import { plural, t } from "@lingui/macro";

export const getBulkDigestSuccessMsg = (actionText, success_count, fail_count) => {
    // Message Logics
    const successMsg = plural(
        success_count, {
            one: `# digest successfully ${actionText}`,
            other: `# digests successfully ${actionText}`,
        },
    );

    const skippedMsg = plural(
        fail_count, {
            one: `# digest skipped`,
            other: `# digests skipped`,
        },
    );

    if (success_count > 0 && fail_count > 0)
        return t`${successMsg}, ${skippedMsg}.`;
    if (success_count > 0)
        return t`${successMsg}.`;
    return t`${skippedMsg}.`;
};

export const normalizeStreamToListApiStream = stream => ({
    id: stream.id,
    ext_name: stream.ext_name,
    provider: {
        authentication: stream.flow_provider.authentication,
        name: stream.flow_provider.name,
        short_name: stream.flow_provider.short_name,
    },
});
